<script setup lang="ts">
import { ref,reactive,onMounted } from 'vue'
import config from "../../config.js";
import { errorAlertApp,confirmAlertApp,successAlertApp } from "../../plugins/alert_app";
import { callBarcodeReaderSetting } from "../../plugins/flutter";
import CheckBox from "../../compositions/CheckBox.vue";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

const props = defineProps({
    settings:{
      type:Object,
      required:true,
    },
})
const barcodeWindowWidth = ref(props.settings.barcode_window_width ? parseFloat(props.settings.barcode_window_width)*100 : 55);
const barcodeWindowHeight = ref(props.settings.barcode_window_height ? parseFloat(props.settings.barcode_window_height)*100 : 10);
const barcodeScanMulti = ref(props.settings.barcode_scan_multi == 'true' ? true : false);

const onChangeBarcodeScanMulti = (value) => {
  barcodeScanMulti.value = value ? true : false;
}

const saveSetting = async () => {
  if (barcodeWindowWidth.value < 30) {
    errorAlertApp('横幅が小さすぎると読み取りできないため、もう少し大きくしてください。');
    return;
  }
  if (barcodeWindowHeight.value < 10) {
    errorAlertApp('縦幅が小さすぎると読み取りできないため、もう少し大きくしてください。');
    return;
  }
  let result = await confirmAlertApp('設定を保存しますか？');
  if (result.isConfirmed) {
    callBarcodeReaderSetting({barcode_window_width:(barcodeWindowWidth.value/100).toString(),barcode_window_height:(barcodeWindowHeight.value/100).toString(),barcode_scan_multi:barcodeScanMulti.value});
    successAlertApp('保存しました。');
  }
}
const defaultSetting = async () => {
  let result = await confirmAlertApp('デフォルト設定に戻しますか？');
  if (result.isConfirmed) {
    barcodeWindowWidth.value = 55;
    barcodeWindowHeight.value = 10;
    barcodeScanMulti.value = false;
    callBarcodeReaderSetting({barcode_window_width:'0.55',barcode_window_height:'0.1',barcode_scan_multi:false});
    successAlertApp('保存しました。');
  }
}
const sliderOptions = {
  dotSize: 14,
  height: 4,
  width: 'auto',
  min:0,
  max:100
}
onMounted(() => {
});

</script>

<style scoped>
.button {
  background-color:#F59E12;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
.default-button {
  background-color: #1235F5;
  color: white;
  color:white;
  width:100%;
  border-radius: 0.5em;
  padding:0.5em 3em 0.5em 3em;
}
</style>
<template>
<div ref="element" class="relative">
  <div class="w-fulln flex flex-col">
    <div class="p-2 bg-amber-500 text-white mb-4">バーコードリーダー設定</div>
    <div class=" p-2 m-2 underline">読み取り枠の調整</div>
    <div class=" p-2 flex flex-row items-center justify-start mb-2">
      <div class="w-1/5">横幅：</div>
      <div class="w-4/5 pr-10">
        <vue-slider v-model="barcodeWindowWidth" v-bind="sliderOptions"/>
      </div>
    </div>
    <div class=" p-2 flex flex-row items-center justify-start mb-2">
      <div class="w-1/5">縦幅：</div>
      <div class="w-4/5 pr-10">
        <vue-slider v-model="barcodeWindowHeight" v-bind="sliderOptions"/>
      </div>
    </div>
    <div class="p-2 m-2">
      <div class="mb-2 underline">監査チェック</div>
      <div class="flex justify-start">
        <check-box
          label="連続スキャン"
          :value="barcodeScanMulti"
          :on-change="onChangeBarcodeScanMulti"
        ></check-box>
      </div>
    </div>
  </div>
  <div class="w-full mt-8 p-2">
    <button type="button" @click="saveSetting" class="button">保存する</button>
  </div>
  <div class="mt-4 mb-8 p-2">
    <button type="button" @click="defaultSetting" class="default-button">デフォルトに戻す</button>
  </div>
</div>
</template>

